exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.link-text[data-v-74d5c8e3] {\n  display: inline-block;\n  margin: 5px;\n  cursor: pointer;\n  color: #409eff;\n}\nh3[data-v-74d5c8e3] {\n  padding-top: 20px;\n  padding-bottom: 10px;\n}\n.el-row[data-v-74d5c8e3] {\n  line-height: 36px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74d5c8e3","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/page/college/interviewTjk.vue
// module id = 1191
// module chunks = 0